import { render, staticRenderFns } from "./reportDashboard.vue?vue&type=template&id=58563741&scoped=true&"
import script from "./reportDashboard.vue?vue&type=script&lang=js&"
export * from "./reportDashboard.vue?vue&type=script&lang=js&"
import style0 from "./reportDashboard.vue?vue&type=style&index=0&id=58563741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58563741",
  null
  
)

export default component.exports